import { trackNavigationClick } from '@ecomm/cdp-tracking'
import { useCallback } from 'react'
import { useTracking } from 'react-tracking'

export const useTrackingDropdownMenu = () => {
  const tracking = useTracking()

  return useCallback(
    (label: string) => {
      tracking.trackEvent({
        event: 'navigation-link',
        eventAction: 'click',
        eventCategory: 'navigation',
        label: label
      })
      trackNavigationClick({
        action: 'click',
        navElement: label
      })
    },
    [tracking]
  )
}
